<template lang='pug'>
  i.svg-icon.svg-icon-edit
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M21.271,52.779c-0.326,0.241-0.57,0.573-0.709,0.948l-5.002,13.886c-0.233,0.645-0.125,1.36,0.281,1.914 c0.327,0.441,0.814,0.726,1.345,0.805c0.129,0.019,0.265,0.028,0.403,0.019l14.738-0.722c0.409-0.021,0.797-0.157,1.118-0.399 l36.819-27.237L58.092,25.544L21.271,52.779z')

      path(d='M83.775,19.266c-3.357-4.538-9.776-5.498-14.31-2.14l-6.439,4.764l12.168,16.45l6.44-4.765 c2.195-1.621,3.629-4.005,4.032-6.71C86.071,24.161,85.399,21.461,83.775,19.266z')
      
      path(d='M85.649,83.825c0,1.423-1.26,2.577-2.815,2.577H18.517c-1.556,0-2.817-1.154-2.817-2.577V77.17 c0-1.425,1.262-2.578,2.817-2.578h64.317c1.556,0,2.815,1.153,2.815,2.578V83.825z')



</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>